import { useAtom } from 'jotai';
import { Stack, Text } from '@pairy/pds-react';

import type { ZoomLevel } from '../../../../../../types/viewer';
import {
  isDisableHelpersAtom,
  zoomLevelAtom,
} from '../../../../../../store/index.atom';

import * as Styled from './index.styles';

const DesktopZoomButton = () => {
  const [zoomLevel, setZoomLevel] = useAtom(zoomLevelAtom);
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  const handleZoom = (amount: number) => {
    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    const newZoomLevel = zoomLevel + amount;
    if (newZoomLevel >= 0.5 && newZoomLevel <= 1.5) {
      setZoomLevel(newZoomLevel as ZoomLevel);
    }
  };

  const handleClickZoomIn = () => {
    handleZoom(0.25);
  };

  const handleClickZoomOut = () => {
    handleZoom(-0.25);
  };

  return (
    <Styled.Button
      className={isDisableHelpers ? 'disable' : ''}
      variant="zinc_500"
      radius={9999}
      paddingY={16}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isDisableHelpers) {
          setIsDisableHelpers(false);
          return;
        }
      }}
    >
      <Stack
        direction="row"
        gap={16}
        justifyContent="center"
        alignItems="center"
      >
        <Styled.Icon
          icon="ph:magnifying-glass-plus"
          size={19}
          color={zoomLevel === 1.5 ? 'zinc_400' : 'black'}
          onClick={handleClickZoomIn}
        />
        {zoomLevel !== 1 && (
          <Text variant="lg-medium" color="black">
            {zoomLevel * 100}%
          </Text>
        )}
        <Styled.Icon
          icon="ph:magnifying-glass-minus"
          size={19}
          color={zoomLevel === 0.5 ? 'zinc_400' : 'black'}
          onClick={handleClickZoomOut}
        />
      </Stack>
    </Styled.Button>
  );
};

export default DesktopZoomButton;
